import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../assets/site/apple-icon-180x180.png';

export const generatePDFReport = (type, title, headers, dataRows, totalsRow) => {
  const doc = new jsPDF('landscape'); // Landscape to fit columns
  
  const img = new Image();
  img.src = logo;
  
  img.onload = () => {
    // Logo
    doc.addImage(img, 'PNG', 14, 12, 16, 16);

    // Title
    doc.setFontSize(18);
    doc.setTextColor(45, 132, 255); // var(--accent-blue)
    doc.text(`Finaculator - ${title}`, 34, 22);
    
    // Timestamp
    doc.setFontSize(10);
    doc.setTextColor(136, 146, 176);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 34, 30);

    // Table
    autoTable(doc, {
      startY: 36,
      head: [headers],
      body: [
        ...dataRows,
        totalsRow
      ],
      theme: 'grid',
      headStyles: {
        fillColor: [10, 31, 20], // dark green shade
        textColor: [255, 255, 255],
        fontSize: 9,
        fontStyle: 'bold'
      },
      bodyStyles: {
        fontSize: 8,
        textColor: [40, 40, 40]
      },
      alternateRowStyles: {
        fillColor: [248, 248, 248]
      },
      footStyles: {
        fillColor: [240, 244, 255],
        textColor: [10, 10, 10],
        fontStyle: 'bold'
      },
      didParseCell: function (data) {
        // Highlight the totals row
        if (data.row.index === dataRows.length) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = [230, 240, 255];
        }
      },
      margin: { bottom: 30 }
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      
      // Footer: Disclaimer
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text("Disclaimer: This is a system-generated report and does not require a signature.", 14, pageHeight - 15);
      
      // Footer: Powered by and Developed by
      doc.setFontSize(8);
      doc.text("Powered by Finaculator | Developed by biatom.org", doc.internal.pageSize.getWidth() - 14, pageHeight - 15, { align: 'right' });
    }

    doc.save(`Finaculator_${type}_Report_${new Date().getTime()}.pdf`);
  };
  
  img.onerror = () => {
    // Fallback if logo fails to load
    doc.setFontSize(18);
    doc.setTextColor(45, 132, 255);
    doc.text(`Finaculator - ${title}`, 14, 22);
    doc.setFontSize(10);
    doc.setTextColor(136, 146, 176);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 30);

    autoTable(doc, {
      startY: 36,
      head: [headers],
      body: [...dataRows, totalsRow],
      theme: 'grid',
      headStyles: { fillColor: [10, 31, 20], textColor: [255, 255, 255], fontSize: 9, fontStyle: 'bold' },
      bodyStyles: { fontSize: 8, textColor: [40, 40, 40] },
      alternateRowStyles: { fillColor: [248, 248, 248] },
      footStyles: { fillColor: [240, 244, 255], textColor: [10, 10, 10], fontStyle: 'bold' },
      didParseCell: function (data) {
        if (data.row.index === dataRows.length) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = [230, 240, 255];
        }
      },
      margin: { bottom: 30 }
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text("Disclaimer: This is a system-generated report and does not require a signature.", 14, pageHeight - 15);
      doc.text("Powered by Finaculator | Developed by biatom.org", doc.internal.pageSize.getWidth() - 14, pageHeight - 15, { align: 'right' });
    }
    doc.save(`Finaculator_${type}_Report_${new Date().getTime()}.pdf`);
  };
};
